<template>
  <section class="auto-insurance__index column-index">
    <change-store></change-store>
    <column-info :column-list="columnList"></column-info>
  </section>
</template>

<script>
import ChangeStore from '../components/ChangeStore'
import ColumnInfo from '../components/ColumnInfo'
import authApi from '../../common/auth'

export default {
  components: {
    ChangeStore,
    ColumnInfo
  },
  data() {
    return {
      defaultColumns: [
        {
          title: '优惠券',
          hasAuth: true,
          items: [
            {
              name: '优惠券审核',
              icon: 'coupon-audit',
              link: '/cou_check'
            }
          ]
        },
        {
          title: '数据统计',
          hasAuth: true,
          items: [
            {
              name: '续保统计',
              icon: 'insurance',
              link: '/manageAnalysis/insurance'
            }
          ]
        }
      ]
    }
  },
  created () {
    this.setColumnLink()
    this.setColumnAuth()
  },
  methods: {
    async setColumnAuth () {
      const { authList } = await this.$store.state.promiseAuth
      const viewSelf = authList.includes(authApi.busiAnalysis.view_self)
      let insuranceAuth = false

      if (viewSelf) {
        insuranceAuth = true
      } else {
        insuranceAuth = authList.includes(authApi.busiAnalysis.insurance_analysis)
      }
      if (!insuranceAuth) {
        this.defaultColumns[1].hasAuth = false
      }
    },
    async setColumnLink () {
      try {
        const { code, data, message } = await this.$rest.dataAnalysis.getCarAuth()

        if (code !== 0) {
          this.showToast(message)
          return
        }

        const storeId = data.store_id
        const hasAuth = data.view_group
        if (!hasAuth) {
          this.defaultColumns[1].items[0].link = `/manageAnalysis/insurance/${storeId}`
        }
      } catch (e) {
        this.showToast(e.message)
      }
    }
  },
  computed: {
    columnList () {
      return this.defaultColumns.filter(column => column.hasAuth === true)
    }
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/base/fn.less";
  @import "../../stylesheets/modules/manage/columnList.less";
  .auto-insurance__index {
    .column {
      @selectors: coupon-audit, insurance;
      each(@selectors, {
        .@{value} {
          background: url('../../stylesheets/images/index/@{value}.png') no-repeat center center / cover;
          background-size: contain;
        }
      })
    }
  }
</style>
